import posthog from "posthog-js";

const apiKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const apiHost =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || "https://us.i.posthog.com";

if (apiKey) {
  posthog.init(apiKey, {
    api_host: apiHost,
    person_profiles: "identified_only",
  });
}

export default posthog;
